(function () {
  const ageGate = document.querySelector("[data-age-gate]");
  const confirmButton = document.querySelector("[data-age-confirm]");
  const denyButton = document.querySelector("[data-age-deny]");
  const denyNotice = document.querySelector("[data-age-notice]");
  const storageKey = "aplus-vapes-age-confirmed";

  function getStoredValue(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function setStoredValue(key, value) {
    try {
      if (window.localStorage) window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function showAgeGate() {
    if (!ageGate) return;
    ageGate.hidden = false;
    document.body.classList.add("is-locked");
    confirmButton && confirmButton.focus();
  }

  function hideAgeGate() {
    if (!ageGate) return;
    ageGate.hidden = true;
    document.body.classList.remove("is-locked");
  }

  if (ageGate && getStoredValue(storageKey) !== "yes") {
    showAgeGate();
  }

  confirmButton && confirmButton.addEventListener("click", function () {
    setStoredValue(storageKey, "yes");
    hideAgeGate();
  });

  denyButton && denyButton.addEventListener("click", function () {
    if (denyNotice) denyNotice.hidden = false;
  });

  const catalogRoot = document.querySelector("[data-catalog-root]");
  if (!catalogRoot) return;

  const productList = catalogRoot.querySelector("[data-product-list]");
  const search = catalogRoot.querySelector("[data-search]");
  const brand = catalogRoot.querySelector("[data-brand]");
  const flavour = catalogRoot.querySelector("[data-flavour]");
  const type = catalogRoot.querySelector("[data-type]");
  const sort = catalogRoot.querySelector("[data-sort]");
  const results = catalogRoot.querySelector("[data-results-count]");
  let products = [];
  const brands = [
    "AL FAKHER",
    "ALLO",
    "BOOSTED",
    "BREEZE",
    "EDGE",
    "FEED SYNC",
    "FLAVOUR BEAST",
    "OVNS",
    "POP HYBRID",
    "STLTH",
    "TITAN",
    "VUSE",
    "ZPOD"
  ];
  const flavourKeywords = [
    "apple",
    "banana",
    "berry",
    "blue razz",
    "blueberry",
    "cherry",
    "citrus",
    "cola",
    "cranberry",
    "dragon fruit",
    "fruit",
    "grape",
    "guava",
    "ice",
    "lemon",
    "lime",
    "mango",
    "melon",
    "mint",
    "orange",
    "peach",
    "pineapple",
    "raspberry",
    "strawberry",
    "tobacco",
    "watermelon"
  ];

  function clean(value) {
    return String(value || "").trim();
  }

  function titleCase(value) {
    return value.replace(/\w\S*/g, function (part) {
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
  }

  function unique(values) {
    return Array.from(new Set(values.map(clean).filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function option(value, label) {
    const node = document.createElement("option");
    node.value = value;
    node.textContent = label;
    return node;
  }

  function fillSelect(select, values, firstLabel) {
    if (!select) return;
    select.replaceChildren(option("all", firstLabel));
    values.forEach(function (value) {
      select.appendChild(option(value, value));
    });
  }

  function inferBrand(product) {
    const title = clean(product.title).toUpperCase().replace(/ALFAKHER/g, "AL FAKHER");
    const tagText = (product.tags || []).join(" ").toUpperCase();
    const vendor = clean(product.vendor || product.brand).toUpperCase();

    return brands.find(function (brandName) {
      return title.includes(brandName);
    }) || brands.find(function (brandName) {
      return tagText.includes(brandName);
    }) || brands.find(function (brandName) {
      return vendor.includes(brandName);
    }) || clean(product.vendor || product.brand).replace(/\+ VAPE/i, "A+ Vapes") || "A+ Vapes";
  }

  function inferFlavours(product) {
    const tagFlavours = (product.tags || []).map(function (tag) {
      const match = clean(tag).match(/^flavou?r[:\s-]+(.+)$/i);
      return match ? titleCase(match[1]) : "";
    }).filter(Boolean);
    const haystack = " " + clean(product.title).toLowerCase().replace(/[^a-z0-9]+/g, " ") + " ";
    const titleFlavours = flavourKeywords.filter(function (keyword) {
      const phrase = keyword.replace(/[^a-z0-9]+/g, " ");
      return haystack.includes(" " + phrase + " ");
    }).map(titleCase);

    return unique(tagFlavours.concat(titleFlavours)).slice(0, 5);
  }

  function normalizeProduct(product) {
    if (!product.product_type && !product.vendor && !product.images) {
      return {
        title: clean(product.title),
        brand: clean(product.brand) || "A+ Vapes",
        type: clean(product.type) || "Catalog item",
        tags: product.tags || [],
        flavours: product.flavours || [],
        image: product.image || ""
      };
    }

    return {
      title: clean(product.title),
      brand: inferBrand(product),
      type: clean(product.product_type) || "Catalog item",
      tags: (product.tags || []).map(clean).filter(Boolean),
      flavours: inferFlavours(product),
      image: product.images && product.images[0] ? product.images[0].src : "",
      available: product.variants ? product.variants.some(function (variant) {
        return variant.available;
      }) : true
    };
  }

  function pagedUrl(source, page) {
    const url = new URL(source, window.location.origin);
    if (!url.searchParams.has("limit")) url.searchParams.set("limit", "250");
    url.searchParams.set("page", String(page));
    return url.toString();
  }

  function loadJsonCatalog(source) {
    return fetch(source).then(function (response) {
      if (!response.ok) throw new Error("Catalog failed to load");
      return response.json();
    }).then(function (data) {
      return (data.products || []).map(normalizeProduct);
    });
  }

  function loadShopifyCatalog(source) {
    const maxPages = Math.max(1, Math.min(Number(catalogRoot.dataset.maxPages) || 20, 20));
    const loaded = [];

    function loadPage(page) {
      return fetch(pagedUrl(source, page)).then(function (response) {
        if (!response.ok) throw new Error("Catalog failed to load");
        return response.json();
      }).then(function (data) {
        const pageProducts = data.products || [];
        loaded.push.apply(loaded, pageProducts);
        if (pageProducts.length === 250 && page < maxPages) {
          return loadPage(page + 1);
        }
        return loaded.map(normalizeProduct);
      });
    }

    return loadPage(1);
  }

  function loadCatalog() {
    const source = catalogRoot.dataset.source || "/products.json";
    if (source.includes("catalog-data.json")) {
      return loadJsonCatalog(source);
    }
    return loadShopifyCatalog(source);
  }

  function productText(product) {
    return [
      product.title,
      product.brand,
      product.type,
      ...(product.tags || []),
      ...(product.flavours || [])
    ].join(" ").toLowerCase();
  }

  function matches(product) {
    const query = search && search.value ? search.value.trim().toLowerCase() : "";
    const selectedBrand = brand && brand.value ? brand.value : "all";
    const selectedFlavour = flavour && flavour.value ? flavour.value : "all";
    const selectedType = type && type.value ? type.value : "all";

    return (!query || productText(product).includes(query)) &&
      (selectedBrand === "all" || product.brand === selectedBrand) &&
      (selectedFlavour === "all" || (product.flavours || []).includes(selectedFlavour)) &&
      (selectedType === "all" || product.type === selectedType);
  }

  function compareProducts(first, second) {
    const mode = sort && sort.value ? sort.value : "az";
    if (mode === "za") return second.title.localeCompare(first.title);
    if (mode === "family") {
      return first.brand.localeCompare(second.brand) || first.title.localeCompare(second.title);
    }
    return first.title.localeCompare(second.title);
  }

  function pill(text) {
    const item = document.createElement("span");
    item.className = "catalog-pill";
    item.textContent = text;
    return item;
  }

  function renderProduct(product) {
    const row = document.createElement("article");
    row.className = "catalog-row";

    const media = document.createElement("div");
    media.className = "catalog-row__media";
    if (product.image) {
      const image = document.createElement("img");
      image.src = product.image;
      image.alt = product.title;
      image.loading = "lazy";
      media.appendChild(image);
    } else {
      media.textContent = product.brand.slice(0, 2);
    }

    const productCell = document.createElement("div");
    productCell.className = "catalog-row__product";
    const productTextWrap = document.createElement("div");
    const title = document.createElement("h2");
    title.textContent = product.title;
    productTextWrap.appendChild(title);
    if (product.tags && product.tags.length) {
      const tags = document.createElement("p");
      tags.textContent = product.tags.slice(0, 3).join(" / ");
      productTextWrap.appendChild(tags);
    }
    productCell.append(media, productTextWrap);

    const brandCell = document.createElement("div");
    brandCell.className = "catalog-row__meta";
    brandCell.textContent = product.brand;

    const typeCell = document.createElement("div");
    typeCell.className = "catalog-row__meta";
    typeCell.textContent = product.type;

    const flavourCell = document.createElement("div");
    flavourCell.className = "catalog-row__flavours";
    const flavours = product.flavours && product.flavours.length ? product.flavours : ["Profile varies"];
    flavours.forEach(function (value) {
      flavourCell.appendChild(pill(value));
    });

    row.append(productCell, brandCell, typeCell, flavourCell);
    return row;
  }

  function renderCatalog() {
    if (!productList) return;
    const head = productList.querySelector(".catalog-list__head");
    const visible = products.filter(matches).sort(compareProducts);

    productList.replaceChildren(head);
    visible.forEach(function (product) {
      productList.appendChild(renderProduct(product));
    });

    if (results) {
      const sourceLabel = catalogRoot.dataset.sourceLabel || "catalog";
      results.textContent = visible.length + " of " + products.length + " products shown from " + sourceLabel + ". Browse-only catalog. No prices or online ordering.";
    }
  }

  function hydrateFilters() {
    fillSelect(brand, unique(products.map((product) => product.brand)), "All families");
    fillSelect(type, unique(products.map((product) => product.type)), "All types");
    fillSelect(
      flavour,
      unique(products.flatMap((product) => product.flavours || [])),
      "All flavours"
    );
  }

  [search, brand, flavour, type, sort].forEach(function (control) {
    control && control.addEventListener("input", renderCatalog);
  });

  loadCatalog()
    .then(function (data) {
      products = data;
      hydrateFilters();
      renderCatalog();
    })
    .catch(function () {
      if (results) {
        results.textContent = "Catalog could not load. Please refresh the page.";
      }
    });
})();
